import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
// import { HomePage } from '@/pages/HomePage';
import { CategoryPage } from '@/pages/CategoryPage';
import { CityCategoryPage } from '@/pages/CityCategoryPage';
import { PolicyPage } from './pages/PolicyPage';
import { TermsPage } from './pages/TermsPage';
import { ContactPage } from './pages/ContactPage';
import { CityNewsPage } from './pages/CityNewsPage';

export const router = createBrowserRouter([
  { path: '/policy', element: <PolicyPage /> },
  { path: '/terms', element: <TermsPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/', element: <CategoryPage /> },

// city news page (specific)
{ path: '/:country/:state/:city/news', element: <CityNewsPage /> },
{ path: '/:country/:state/:city/events', element: <CityNewsPage /> },


// city routines (general)
{ path: '/:country/:state/:city/:routineKey', element: <CityCategoryPage /> },
{ path: '/:country/:state/:city', element: <CityNewsPage /> },

  // base categories
  { path: '/:categoryName', element: <CategoryPage /> },

  { path: '*', element: <Navigate to="/" replace /> },
]);
